const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8078'

function getToken() {
    return localStorage.getItem('bankroll_token')
}

async function request(path, options = {}) {
    const token = getToken()
    const headers = {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
    }

    const response = await fetch(`${BASE_URL}${path}`, { ...options, headers })

    if (response.status === 401) {
        // Token expired or invalid — clear storage and reload to login
        localStorage.removeItem('bankroll_token')
        localStorage.removeItem('bankroll_user')
        window.dispatchEvent(new Event('bankroll:logout'))
    }

    if (!response.ok) {
        const body = await response.json().catch(() => ({}))
        throw new Error(body.detail || `Request failed (${response.status})`)
    }

    // 204 No Content
    if (response.status === 204) return null
    return response.json()
}

export const api = {
    get:    (path)        => request(path),
    post:   (path, body)  => request(path, { method: 'POST',  body: JSON.stringify(body) }),
    put:    (path, body)  => request(path, { method: 'PUT',   body: JSON.stringify(body) }),
    delete: (path)        => request(path, { method: 'DELETE' }),
}
